<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  data() {
    return {
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: "FINE_STIMULATION_TRAINING",
      games: [],
      gameId: undefined,
      dynamicValidateForm: {
        domains: []
      },
      tempFormData: []
    };
  },
  computed: {
    hasDiff() {
      if (
        JSON.stringify(this.dynamicValidateForm.domains) !=
        JSON.stringify(this.tempFormData)
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      if (this.games.length) {
        let activeGame = this.games[0];
        this.gameId = activeGame.id;
        this.loadStatistic();
      }
    },
    onSelectGame(gameId) {
      this.loadStatistic();
    },
    onSelectGameType(type) {
      if (type) {
        this.gameId = undefined;
        this.games = [];
        this.loadData();
      }
    },
    async loadStatistic() {
      const result = await this.$http.adminGetTrainWeight(this.gameId);
      const temp = [];
      if (result.weight) {
        for (let item in result.weight) {
          temp.push({
            label: item,
            value: result.weight[item]
          });
        }
      }
      this.dynamicValidateForm.domains = cloneDeep(temp);
      this.tempFormData = cloneDeep(temp);
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const temp = {};
          this.dynamicValidateForm.domains.forEach(item => {
            temp[item.label] = item.value;
          });
          const result = await this.$http.updateTrainWeight(this.gameId, temp);
          if (result) {
            this.$message.success("操作成功！");
          }
          this.loadStatistic();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.dynamicValidateForm.domains = cloneDeep(this.tempFormData);
    },
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        value: undefined,
        label: undefined,
        key: Date.now()
      });
    }
  }
};
</script>
<template>
  <div class="trainWeightIndex">
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle" style="vertical-align: top;">训练类别：</span>
        <div class="radioView">
          <span
            v-for="typeInfo in typeSource"
            :key="typeInfo.type + typeInfo.name"
            class="radioCell"
          >
            <el-radio
              v-model="type"
              @change="onSelectGameType"
              :label="typeInfo.type"
            >{{typeInfo.name}}</el-radio>
          </span>
        </div>
      </el-col>
      <el-col :span="24" class="colStyle">
        <span class="searchTitle">选择游戏：</span>
        <span>
          <el-select
            size="medium"
            v-model="gameId"
            @change="onSelectGame"
            class="selectInputStyle"
            v-if="games && games.length > 0"
          >
            <el-option
              v-for="(game, index) in games"
              :key="index + '_gameName'"
              :label="game.name"
              :value="game.id"
            />
          </el-select>
        </span>
      </el-col>
    </el-row>
    <div class="parameterView">
      <el-row :gutter="24" class="parameterTitleView">
        <el-col :span="24">
          <span class="parameterTitle">参数配置</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="parameterCellView">
        <el-form
          :model="dynamicValidateForm"
          ref="dynamicValidateForm"
          label-width="80px"
          label-position="left"
          class="parameterCellForm"
        >
          <el-form-item
            v-for="(domain, index) in dynamicValidateForm.domains"
            :label="'参数' + index"
            class="parameterFormItem"
            :key="domain.key"
            :prop="'domains.' + index + '.value'"
            :rules="{required: true, message: '请完成必填项', trigger: 'blur'}"
          >
            <el-input class="domainsInput" v-model="domain.label"></el-input>
            <span class="lableView">权重</span>
            <el-input-number
              :controls="false"
              :precision="2"
              class="domainsInput"
              v-model="domain.value"
            ></el-input-number>
            <el-button
              class="removeIconButton"
              icon="el-icon-close"
              @click.prevent="removeDomain(domain)"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              :disabled="hasDiff"
              type="primary"
              @click="submitForm('dynamicValidateForm')"
            >提交</el-button>
            <el-button @click="addDomain">新增参数</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
            <el-button @click="addDomain">新增域名</el-button>
            <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
          </el-form-item>-->
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainWeightIndex {
  padding-left: 30px;
  padding-top: 15px;
  .gameSearchForm {
    margin: 0px 0px 10px !important;
    color: rgba(89, 94, 122, 1);
    // width: 00px;
    .colStyle {
      padding: 0 !important;
    }
    .selectInputStyle {
      width: 150px;
    }
    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .radioView {
      width: 75%;
      display: inline-block;
    }
    .radioCell {
      width: 140px;
      margin-bottom: 12px;
      display: inline-block;
    }
  }
  .parameterView {
    border: 1px solid #d5dae0;
    border-radius: 4px;
    width: 95%;
    .parameterTitleView {
      margin: 0px !important;
      background-color: #f2f4f6;
      height: 44px;

      .parameterTitle {
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        color: rgba(34, 39, 46, 1);
      }
    }
    .parameterCellView {
      margin: 0px 0px 10px !important;
      min-height: 200px;

      .parameterCellForm {
        padding-left: 12px;
        .parameterFormItem {
          margin-top: 10px;
        }
      }
      .domainsInput {
        width: 100px;
      }
      .lableView {
        display: inline-block;
        width: 40px;
        margin: auto 5px;
        color: rgba(93, 93, 93, 1);
      }
      .removeIconButton {
        border: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/trainWeight/index.vue